/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInvestmentStatements} from '../api'

 export const useQueryGetInvestmentStatements = createReactQueryHook('getInvestmentStatements', getInvestmentStatements)
